import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import Home from '../Home';

import DataContext from '../../contexts/DataContext';
import ReportFormModel from '../../components/Form/ReportFormModel';
import ValidationFormSchema from '../../components/Form/ValidationFormSchema';
import { APP_ENV } from '../../../../shared/config/constants';
import { SENTRY_DSN } from '../../config/constants';

if (APP_ENV !== 'development' && APP_ENV !== 'ci') {
  Sentry.init({
    dsn: String(SENTRY_DSN),
    integrations: [new Integrations.BrowserTracing()],
    attachStacktrace: true,
    tracesSampleRate: 1.0,
    environment: APP_ENV,
    allowUrls: [/^https?:\/\/[^/]+\/libraries\/hvc_widgets\//],
  });
}

const App = () => {
  const { t } = useTranslation();
  const [address, setAddress] = React.useState(null);
  const [categories, setCategories] = React.useState([]);
  const [subcategories, setSubcategories] = React.useState([]);
  const [inBounds, setInbounds] = React.useState('');
  const [latlng, setLatLng] = React.useState(null);
  const [validationSchema, setValidationSchema] = React.useState(ValidationFormSchema(t)[0]);
  const [initialValues, setInitialValues] = useState(ReportFormModel);
  const [categoryId, setCategoryId] = useState(0);
  const [alert, setAlert] = useState({ show: false, text: '', alert: '' });

  // TODO: Remove this eslint-disable line and fix the linting issue.
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const dataContextData = {
    address,
    categories,
    subcategories,
    inBounds,
    latlng,
    validationSchema,
    initialValues,
    categoryId,
    alert,
    updateAddress: setAddress,
    updateCategories: setCategories,
    updateSubcategories: setSubcategories,
    updateInBounds: setInbounds,
    updateLatLng: setLatLng,
    updateValidationSchema: setValidationSchema,
    updateInitialValues: setInitialValues,
    updateCategoryId: setCategoryId,
    updateAlert: setAlert,
  };

  return (
    <DataContext.Provider value={dataContextData}>
      <Home />
    </DataContext.Provider>
  );
};

export default App;
